(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["get-started-paths"] && !Shopify.designMode) return;
  try {
    
  class PathSwitcher extends HTMLElement {
    connectedCallback() {
      this.switchEl = this.querySelector('.paths__switch');
      this.buttons = Array.from(this.querySelectorAll('.paths__switch-btn'));
      this.panels = Array.from(this.querySelectorAll('.paths__panel'));

      this.buttons.forEach((btn) => {
        btn.addEventListener('click', () => this.activate(btn.dataset.path));
      });
    }

    activate(path) {
      this.switchEl.dataset.active = path;

      this.buttons.forEach((btn) => {
        btn.setAttribute('aria-selected', btn.dataset.path === path ? 'true' : 'false');
      });

      this.panels.forEach((panel) => {
        panel.dataset.visible = panel.dataset.panel === path ? 'true' : 'false';
      });
    }
  }

  customElements.define('path-switcher', PathSwitcher);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"]) return;
  try {
    
  class HeroStatsCounter extends HTMLElement {
    connectedCallback() {
      this.numbers = Array.from(this.querySelectorAll('.hero__stat-number'));
      this.animated = false;

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.animated) {
              this.animated = true;
              this.numbers.forEach((el) => this.animateNumber(el));
              this.observer.disconnect();
            }
          });
        },
        { threshold: 0.4 }
      );

      this.observer.observe(this);
    }

    animateNumber(el) {
      const target = parseFloat(el.dataset.target) || 0;
      const suffix = el.dataset.suffix || '';
      const duration = 1500;
      const start = performance.now();

      const step = (now) => {
        const elapsed = now - start;
        const progress = Math.min(elapsed / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        const value = Math.floor(eased * target);
        el.textContent = value.toLocaleString() + suffix;

        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          el.textContent = target.toLocaleString() + suffix;
        }
      };

      requestAnimationFrame(step);
    }
  }

  customElements.define('hero-stats-counter', HeroStatsCounter);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pricing-tiers"] && !Shopify.designMode) return;
  try {
    
  class TierCarousel extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('.tier-card'));
      this.ticking = false;
      this.hintPlayed = false;

      this.onScroll = this.onScroll.bind(this);
      this.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });

      this.update();

      this.hintObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.hintPlayed) {
              this.hintPlayed = true;
              this.playSwipeHint();
              this.hintObserver.disconnect();
            }
          });
        },
        { threshold: 0.6 }
      );
      this.hintObserver.observe(this);
    }

    disconnectedCallback() {
      this.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      if (this.hintObserver) this.hintObserver.disconnect();
    }

    isMobile() {
      return window.innerWidth <= 900;
    }

    playSwipeHint() {
      if (!this.isMobile()) return;
      const tier2 = this.querySelector('.tier-card--tier2');
      if (!tier2) return;
      const target = tier2.offsetLeft - (this.clientWidth - tier2.offsetWidth) / 2;

      setTimeout(() => {
        this.scrollLeft = target;
        setTimeout(() => {
          this.scrollLeft = 0;
        }, 500);
      }, 600);
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.update();
        this.ticking = false;
      });
    }

    update() {
      if (!this.isMobile()) {
        this.cards.forEach((card) => {
          card.classList.toggle('tier-card--featured', card.classList.contains('tier-card--tier1'));
        });
        return;
      }

      const containerCenter = this.scrollLeft + this.clientWidth / 2;
      let closest = null;
      let closestDistance = Infinity;

      this.cards.forEach((card) => {
        const cardCenter = card.offsetLeft + card.offsetWidth / 2;
        const distance = Math.abs(cardCenter - containerCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          closest = card;
        }
      });

      this.cards.forEach((card) => {
        card.classList.toggle('tier-card--featured', card === closest);
      });
    }
  }

  if (!customElements.get('tier-carousel')) {
    customElements.define('tier-carousel', TierCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stats"] && !Shopify.designMode) return;
  try {
    
  class StatsCounter extends HTMLElement {
    connectedCallback() {
      this.numbers = Array.from(this.querySelectorAll('.stat__number'));
      this.animated = false;

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.animated) {
              this.animated = true;
              this.numbers.forEach((el) => this.animateNumber(el));
              this.observer.disconnect();
            }
          });
        },
        { threshold: 0.4 }
      );

      this.observer.observe(this);
    }

    animateNumber(el) {
      const target = parseFloat(el.dataset.target) || 0;
      const suffix = el.dataset.suffix || '';
      const duration = 1500;
      const start = performance.now();

      const step = (now) => {
        const elapsed = now - start;
        const progress = Math.min(elapsed / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        const value = Math.floor(eased * target);
        el.textContent = value.toLocaleString() + suffix;

        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          el.textContent = target.toLocaleString() + suffix;
        }
      };

      requestAnimationFrame(step);
    }
  }

  customElements.define('stats-counter', StatsCounter);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["webinar-gate"] && !Shopify.designMode) return;
  try {
    
  class WebinarGate extends HTMLElement {
    connectedCallback() {
      this.wrap = this.querySelector('[data-webinar-video]');
      this.form = this.querySelector('[data-webinar-form]');

      if (localStorage.getItem('mgb-webinar-unlocked') === 'true') {
        this.unlock();
      }

      this.form.addEventListener('submit', (e) => {
        e.preventDefault();
        localStorage.setItem('mgb-webinar-unlocked', 'true');
        this.unlock();
        this.submitToCustomerList();
      });
    }

    unlock() {
      this.wrap.classList.remove('is-locked');
    }

    submitToCustomerList() {
      const formData = new FormData(this.form);
      fetch(this.form.action, {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' },
      }).catch((error) => {
        console.error('Webinar signup submission failed:', error);
      });
    }
  }

  customElements.define('webinar-gate', WebinarGate);

  } catch(e) { console.error(e); }
})();
})();
